import React from "react";
import PropTypes from "prop-types";

const FooterLinks = props => (
    <footer
        className={`footerlinks__container ${
            props.simpleFooter ? `footerlinks__container--simple` : ``
        }`}
    >
        <div className="section__content section__content--footer">
            {props.links && (
                <ul className="footer-links">
                    {props.links.map((item, index) => {
                        return (
                            <li key={index}>
                                <a href={item.href}>{item.title}</a>
                            </li>
                        );
                    })}
                </ul>
            )}
            <p className="page__copy--footer">
                Created by{" "}
                <a href="https://playgroundinc.com/">Playground Inc</a>
            </p>
        </div>
    </footer>
);

FooterLinks.propTypes = {
    authUrl: PropTypes.string,
    links: PropTypes.array,
    simpleFooter: PropTypes.bool
};

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/components/landingPage/FooterLinks.jsx